import { useState } from 'react';
import { Footer, Header } from '../components/Brand.tsx';
import { SignInFlow } from '../components/SignInFlow.tsx';
import { cleanHandleInput } from '../lib/handle-check.ts';
import { navigate } from '../lib/router.ts';

/** Where to go after signing in: a path on this site only (e.g. back to a watch page to turn on alerts). */
function nextPath(): string | null {
  const next = new URLSearchParams(location.search).get('next');
  return next && next.startsWith('/') && !next.startsWith('//') && !next.startsWith('/\\') ? next : null;
}

/** /signin and /claim: the sign-in flow (components/SignInFlow.tsx) as a page. */
export function SignIn({ intent }: { intent: 'signin' | 'claim' }) {
  const [params] = useState(() => new URLSearchParams(location.search));
  const [next] = useState(nextPath);
  /** A link picked on the home page (/claim?handle=…) is filled in for the last step. */
  const [picked] = useState(() => cleanHandleInput(params.get('handle') ?? ''));
  const intro =
    intent === 'claim'
      ? picked
        ? `Sign in with your email or phone to claim zip2live.com/${picked}. No password, and your current links keep working.`
        : 'Claim your personal ZIP2LIVE link and don’t lose your streams. Your current links keep working.'
      : next?.includes('alerts=')
        ? 'Use your email or phone, no password. We only send the go-live alerts you turn on, and the channels you follow come with you.'
        : 'Use your email or phone, no password. New here? This creates your account and keeps anything you streamed on this device.';

  return (
    <div className="flex min-h-full flex-col">
      <Header />
      <main className="mx-auto w-full max-w-md flex-1 px-5 pt-6 pb-16 sm:pt-14">
        <SignInFlow
          intent={intent}
          intro={intro}
          initialMode={params.get('via') === 'phone' ? 'phone' : 'email'}
          initialHandle={picked}
          skipHandle={Boolean(next)}
          onDone={() => navigate(next ?? '/account')}
        />
      </main>
      <Footer />
    </div>
  );
}
